var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamesHubLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 270 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    width: 102,
    height: 59,
    rx: 5,
    fill: "#9D4EDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8008 35.8242H28.2031V41H17.3438L12.168 35.8242V20.2578L17.3438 15.082H20.8008V35.8242ZM25.3711 26.625H37.2266V41H29.5703V31.7617H25.3711V26.625ZM22.168 20.2578V15.082H32.6953L37.2266 20.2578V22.8555H28.5938V20.2578H22.168ZM68.6523 41V20.2578H77.3047V41H68.6523ZM82.1875 25.4336H78.6719V22.9922L81.3867 20.2578H88.0664L90.8398 23.0312V41H82.1875V25.4336ZM95.7227 25.4336H92.207V23.0312L94.8633 20.2578H100.137L104.355 24.5156V41H95.7227V25.4336ZM116.738 41H113.281L108.105 35.8242V25.4336L113.281 20.2578H116.738V41ZM118.105 32.6797V29.0664H122.656V25.4336H118.105V20.2578H125.43L130.605 25.4336V32.6797H118.105ZM118.105 41V36.1562H129.707V38.4023L127.129 41H118.105ZM138.809 20.2578H142.266V27.582H152.109L156.602 32.1133V36.1562L151.777 41H147.969V33.168H138.633L134.141 28.8516V24.9062L138.809 20.2578ZM142.773 37.1914H146.602V41L137.715 40.9805L134.121 36.7227V35.0625H142.773V37.1914ZM147.969 24.0664H143.633V20.2578H152.812L155.898 23.3438V25.6875H147.969V24.0664Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3242 32.3281H65.2539V37.3867H62.3242V41H54.0234V15.082H62.3242V32.3281ZM39.3945 32.582L52.6562 16.8398V27.0938L47.9492 32.3281H52.6562V37.3867H41.4453L39.3945 32.582Z",
    fill: "#9D4EDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174 40.25V14H181.5V25.25H192.75V14H200.25V40.25H192.75V29H181.5V40.25H174ZM207.75 40.25V36.5H204V21.5H211.5V36.5H222.75V21.5H230.25V40.25H207.75ZM237.75 40.25V36.5H234V14H241.5V21.5H256.5V25.25H260.25V36.5H256.5V40.25H237.75ZM241.5 36.5H252.75V25.25H241.5V36.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesHubLogo);
export default __webpack_public_path__ + "static/media/gamesHubLogo.b76cfa941890e0df6e24569422d50a00.svg";
export { ForwardRef as ReactComponent };